module.exports = __webpack_public_path__ + "static/img/ac.76180a51.svg";